import { ActivityDaysServiceProxy } from './../../../../../../shared/service-proxies/service-proxies';
import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import { AllocationSheetsServiceProxy, AllocationSheetStatus, GetStaffAndUserListViewDto, GetPersonnelHoursByProjectFilter, PagedResultDtoOfResourceAllocationListDto, ResourceAllocationDateWiseListDto, ResourceAllocationDetailDto, ResourceAllocationDto, StaffsAndUsersServiceProxy, PersonnelsServiceProxy, PersonnelHoursByProjectDto, PagedResultDtoOfPersonnelHoursByProjectDto } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { forkJoin, ReplaySubject, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { WidgetComponentBaseComponent } from '../widget-component-base';
import { takeUntil } from '@node_modules/rxjs/operators';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { CustomDateAdapter } from '@shared/helpers/CustomDateAdapter';

@Component({
  selector: 'app-widget-personnel-by-day',
  templateUrl: './widget-personnel-by-day.component.html',
  styleUrls: ['./widget-personnel-by-day.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ],
})

  export class WidgetPersonnelByDayComponent extends WidgetComponentBaseComponent
  implements OnInit, OnDestroy {
    selectedDateRange: moment.Moment[] = [
        this.getWeekStartDate(new Date().setDate(new Date().getDate())),
        this.getWeekEndDate(new Date().setDate(new Date().getDate()))
    ];
  filterText: any;
  cols: any[];
  endDate: moment.Moment;
  startDate: moment.Moment;
  projectId:any;
  personnelHoursList: PagedResultDtoOfPersonnelHoursByProjectDto;
  getPersonnelHoursByProjectFilter : GetPersonnelHoursByProjectFilter = new GetPersonnelHoursByProjectFilter();
  maxcount:number=0;
  personnelHours:any[] = [];
  names: any[];
  private _personnels: any[];
  public get personnels(): any[] {
    return this._personnels;
  }
  public set personnels(value: any[]) {
    this._personnels = value;
  }
  status: any[];
  delegationSupervisor: GetStaffAndUserListViewDto;
  supervisorList: GetStaffAndUserListViewDto[] = [];
  allocationSheetStatus = AllocationSheetStatus;
  enumKeys=[];
  nameFilterIsActive: boolean;
  personnelFilterIsActive: boolean;
  statusFilterIsActive: boolean;
  filterNameShow: String;
  filterNameIsSingle: boolean;
  statusSelection:any;
  public userNameFormCtrl: FormControl = new FormControl();
  public userNameFilterFormCtrl : FormControl = new FormControl();
  public filteredName: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public personnelFormCtrl: FormControl = new FormControl();
  public personnelFilterFormCtrl: FormControl = new FormControl();
  public filteredPersonnel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public statusFormCtrl: FormControl = new FormControl();
  public statusFilterFormCtrl: FormControl = new FormControl();
  public filteredStatus: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();
  resourceAllocationDto: ResourceAllocationDto;
  constructor(injector: Injector,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private _sessionService: AppSessionService,
    private _personnelsServiceProxy : PersonnelsServiceProxy,
    private _staffsAndUsersServiceProxy:StaffsAndUsersServiceProxy,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private _fileDownloadService: FileDownloadService,
    private _projectService:ProjectService) {
    super(injector);
  }


  async ngOnInit() {
    this.projectId = await this._projectService.getCurrentOrDefaultProjectId();
    this.startDate =this.selectedDateRange[0];
    this.endDate = this.selectedDateRange[1];
    this.cols = [];
    // this.subDateRangeFilter();
    this.runDelayed(()=>this.GetResourceAllocationList());

    const editData = forkJoin({
      names: this._allocationSheetsServiceProxy
      .getStaffByStaticRole(this._sessionService.defaultSupervisorRoleId),
      personnels: this._personnelsServiceProxy.getAllPersonnelNameValue()
  });

  editData.subscribe((data) => {
      this.filteredName.next(data.names.slice());
      this.filteredPersonnel.next(data.personnels.personnel.slice());
      this.names = data.names;
      this.personnels = data.personnels.personnel;

      for (const [propertyKey, propertyValue] of Object.entries(this.allocationSheetStatus)) {
        if (!Number.isNaN(Number(propertyKey))) {
          continue;
      }
      this.enumKeys.push({ id: propertyValue, name: "allocationEnum_"+propertyKey });
      this.filteredStatus.next(Object.values(this.enumKeys.slice()));
      this.status = this.enumKeys;
  }
  });
  this.initiateFiltersValueChanges();
  }

  GetPrevWeek(){
    var current_start_date = this.startDate.toDate();
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date(current_start_date))).setDate((current_start_date).getDate() - 1)),
      this.getWeekEndDate((new Date(current_start_date)).setDate((current_start_date).getDate() - 1)),
     ]);
  }

   GetNextWeek(){
    var current_end_date = this.endDate.toDate();
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date(current_end_date))).setDate((current_end_date).getDate() + 1)),
      this.getWeekEndDate((new Date(current_end_date)).setDate((current_end_date).getDate() + 1)),
     ]);
  }

  private initiateFiltersValueChanges() {
    this.userNameFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterUserNames();
        });

    this.personnelFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterPersonnel();
        });

    this.statusFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterStatus();
        });
}
 filterUserNames() {
  if (!this.names) {
      return;
  }
  let search = this.userNameFilterFormCtrl.value;
  if (!search) {
      this.filteredName.next(this.names.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredName.next(
      this.names?.filter(
          (param) => `${param.firstName} ${param.lastName}`.toLowerCase().indexOf(search) > -1
      )
  );
}
 filterPersonnel() {
  if (!this.personnels) {
      return;
  }

  let search = this.personnelFilterFormCtrl.value;
  if (!search) {
      this.filteredPersonnel.next(this.personnels.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredPersonnel.next(
      this.personnels?.filter(
        (mgr) => `${mgr.firstName} ${mgr.lastName}`.toLowerCase().indexOf(search) > -1
      )
  );
}
 filterStatus() {
  if (!this.status) {
      return;
  }

  let search = this.statusFilterFormCtrl.value;
  if (!search) {
      this.filteredStatus.next(this.status.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredStatus.next(
      this.status?.filter(
          (status) => this.l(status.name).toLowerCase().indexOf(search) > -1
      )
  );
}

  subDateRangeFilter() {
    abp.event.on(
      'app.dashboardFilters.dateRangePicker.onDateChange',
      this.onDateRangeFilterChange
    );
  }

  onDateRangeFilterChange = (dateRange) => {
    if (
      !dateRange ||
      dateRange.length !== 2 ||
      (this.selectedDateRange[0] === dateRange[0] &&
        this.selectedDateRange[1] === dateRange[1])
    ) {
      return;
    }
    this.startDate=dateRange[0];
    this.endDate =dateRange[1]
    this.GetResourceAllocationList();
  };

  GetResourceAllocationList = (personnelFilter:number[]=null,nameFilter:string[]=null,statusFilter:number[]=null) => {
    this.primengTableHelper.showLoadingIndicator();

    this._personnelsServiceProxy.getPersonnelHoursByProject(this.startDate,this.endDate,personnelFilter,nameFilter,statusFilter,null,0,200).pipe(finalize(() => this.primengTableHelper.hideLoadingIndicator()))
      .subscribe((result) => {
        this.personnelHoursList = result;
        //this.personnelHoursList.items.forEach((item)=>(this.maxcount=item.resourceAllocationDateWiseListDtos.length>this.maxcount?item.resourceAllocationDateWiseListDtos.length:this.maxcount));
        this.primengTableHelper.totalRecordsCount = result.items.length;
        this.primengTableHelper.records = result.items;
        this.primengTableHelper.hideLoadingIndicator();
        this.ConvertObjectToarray(result,this.startDate.toDate(),this.endDate.toDate());
        this.createTableColums(this.startDate.toDate(),this.endDate.toDate());
      });
  }

  ExportData = (type:string) => {

    let personalFilter =[];
    let nameFilter =[];
    let statusFilter=[];

    const params = {
          filterText: this.filterText,
          name: this.userNameFormCtrl.value || null,
          personal: this.personnelFormCtrl.value || null,
          status: this.statusFormCtrl.value || null,
      };
      if(params.personal!=null)
      {
        params.personal.forEach((element: { id: any  }) => {
            personalFilter.push(element.id);
        });
      }
      if(params.name!=null)
      {
        params.name.forEach((element: { staffUser: { staffId: any; }; }) => {
          nameFilter.push(element.staffUser.staffId);
        });
      }

      if(params.status!=null)
      {
        params.status.forEach((element: { id: any; }) => {
          statusFilter.push(element.id);
        });
      }

    this.getPersonnelHoursByProjectFilter.fromDate = this.startDate;
    this.getPersonnelHoursByProjectFilter.toDate = this.endDate;
    this.getPersonnelHoursByProjectFilter.users = nameFilter;
    this.getPersonnelHoursByProjectFilter.names = personalFilter;
    this.getPersonnelHoursByProjectFilter.statusFilter = statusFilter;
    this.getPersonnelHoursByProjectFilter.sorting = null;
    this.getPersonnelHoursByProjectFilter.skipCount = 0;
    this.getPersonnelHoursByProjectFilter.maxResultCount = 200;

    if(type==='xlsx')
    {
    this._personnelsServiceProxy.exportPersonnelHoursByProjectReportToExcel(this.getPersonnelHoursByProjectFilter)
      .subscribe((result) => {
         this._fileDownloadService.downloadTempFile(result);
      });
    }
    if(type==='csv'){

      this._personnelsServiceProxy.exportPersonnelHoursByProjectReportToCSV(this.getPersonnelHoursByProjectFilter)
      .subscribe((result) => {
         this._fileDownloadService.downloadTempFile(result);
      });
    }
  }

  createTableColums(startDate:Date,endDate:Date)
  {
    this.cols=[];
    let dateIterator=new Date(startDate);
    for (dateIterator = startDate; endDate >= dateIterator; dateIterator.setDate(dateIterator.getDate() + 1)) {
      this.cols.push({ field: new Date(dateIterator), header: new Date(dateIterator) });
    }
  }

  groupBy<T>(arr: T[], fn: (item: T) => any) {
    return arr.reduce<Record<string, T[]>>((prev, curr) => {
      const groupKey = fn(curr);
      const group = prev[groupKey] || [];
      group.push(curr);
      return { ...prev, [groupKey]: group };
    }, {});
  }
  startTimeMessage(p)
  {
    if(p.startTime){
      return `Entered ${p.startTime.format('DD/MM/YYYY hh:mm:ss')}`;
    }else{
      return '';
    }

  }

  ConvertObjectToarray(personnelListDto:PagedResultDtoOfPersonnelHoursByProjectDto,startDate:Date,endDate:Date)
  {
    this.personnelHours=[];

    let personnelGroup = this.groupBy(personnelListDto.items, c=> c.personnelId);

    for(let key in personnelGroup){
      const value = personnelGroup[key];
      let personnel={
        personnelId : value[0].personnelId,
        firstName : value[0].firstName,
        lastName : value[0].lastName,
        trade : value[0].trade,
        daysDetails:[],
      }

      const start = new Date(startDate);
      let loop = new Date(start);
      for (let d = loop; endDate >= d; d.setDate(d.getDate() + 1))
      {
        let filterValues = value.filter(c => c.workDay.toDate().getTime() == d.getTime());

        personnel.daysDetails.push({
          workDay: new Date(d.getTime()),
          startTime: filterValues.length > 0? filterValues[0].startTime : null,
          multipleUser: filterValues.map(c=>c.creatorId).length > 1 ? true : false,
          notAllApproved: filterValues.some(f=>f.status != AllocationSheetStatus.ApprovedByProjectAdmin),
          allApproved: filterValues.length > 0 && filterValues.filter(f=>f.status == AllocationSheetStatus.ApprovedByProjectAdmin).length == filterValues.length,
          hoursCount: filterValues.reduce((sum, v) => sum + v.actualHours, 0)
        });
      }
      this.personnelHours.push(personnel)
    }
  }

refresh() {
  this.filtersChange();
}

clear() {
    this.filterText = null;
    this.userNameFormCtrl.reset();
    this.personnelFormCtrl.reset();
    this.statusFormCtrl.reset();
    this.filtersChange();
    this.personnelFilterIsActive = false
    this.nameFilterIsActive = false
    this.statusFilterIsActive = false
}


getWeekEndDate(date): moment.Moment {
    const inputDate = new Date(date);
    const nextWeekStartDate = this.formatDateForReport(new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay()+ (inputDate.getDay() == 0 ? -6:1) )));
    const nextWeekEndDate = this.formatDateForReport(new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay() + 7 )));
    return this.formatDate(nextWeekEndDate);
  }

  formatDate(date):moment.Moment {
    const currentDate = moment(date);
    currentDate.format('DD/MM/YY');
    return currentDate;
  }

  formatDateForReport(date) {
    return new Date(date).setHours(0,0,0,0);
  }

  getWeekStartDate(date) {
    const inputDate = new Date(date);
    const nextWeekStartDate = this.formatDateForReport(new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay()+ (inputDate.getDay() == 0 ? -6:1) )));
    return this.formatDate(nextWeekStartDate);
  }

  onDateSelected(event) {
    var dateString = event.targetElement.value;
    var dateParts = dateString.split("/");
    var jsDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    this.onDateRangeFilterChange([
      this.getWeekStartDate(new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate())),
      this.getWeekEndDate(new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate())),
     ]);
  }

  GetThisWeek(){
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date())).setDate((new Date()).getDate())),
      this.getWeekEndDate((new Date()).setDate((new Date()).getDate())),
     ]);
  }

exportData(type:string)
{
  this.ExportData(type);
}

filtersChange() {
  let personnelFilter =[];
  let nameFilter =[];
  let statusFilter = [];

const params = {
        filterText: this.filterText,
        name: this.userNameFormCtrl.value || null,
        personnel: this.personnelFormCtrl.value || null,
        status: this.statusFormCtrl.value || null,
    };
    if(params.personnel!=null)
    {
      params.personnel.forEach((element: { id: any  }) => {
        personnelFilter.push(element.id);
      });
      if(params.personnel.length > 0) {
        this.personnelFilterIsActive = true
      } else {
        this.personnelFilterIsActive = false
      }
    }
    if(params.name!=null)
    {
      params.name.forEach((element: { staffUser: { staffId: any; }; }) => {
        nameFilter.push(element.staffUser.staffId);
      });
      if(params.name.length > 0) {
        this.nameFilterIsActive = true
      } else {
        this.nameFilterIsActive = false
      }
    }

    if(params.status!=null)
    {
      params.status.forEach((element: { id: any; }) => {
        statusFilter.push(AllocationSheetStatus[element.id]);
      });
      if(params.status.length > 0) {
        this.statusFilterIsActive = true
      } else {
        this.statusFilterIsActive = false
      }
    }

    if(params.personnel != null && params.personnel.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.personnel[0].firstName+' '+params.personnel[0].lastName;
        this.filterNameIsSingle = true;
    } else if(params.name != null && params.name.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.name[0].staffUser.userName;
        this.filterNameIsSingle = true;
    } else if(params.status != null && params.status.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = this.l(params.status[0].name);
        this.filterNameIsSingle = true;
    } else if(params.personnel != null && params.personnel.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.name != null && params.name.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.status != null && params.status.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.personnel != null && params.personnel.length > 0 && params.name != null && params.name.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.personnel != null && params.personnel.length > 0 && params.status != null && params.status.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.status != null && params.status.length > 0 && params.name != null && params.name.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else {
        this.filterNameShow = ""
        this.filterNameIsSingle = false;
    }

    this.GetResourceAllocationList(nameFilter,personnelFilter,statusFilter);
}

async GetPersonnelAllocationDetails(personnelAllocationDateWiseListDto:any,personnelAllocationData:any){
  abp.event.trigger('app.evt.opensubmissionDetailPanel', { fromPersonnelWidget : true, workDay: personnelAllocationDateWiseListDto.workDay, personnelId: personnelAllocationData.personnelId });
  }
}
